/**
 * Application global timer.
 * Via Vue Mixins generate list of callbacks that is supposed to
 * be call periodically.
 */

// Array of timers
const timers = []
// global timer.
setInterval(() => {
  timers.forEach((t) => t.cb())
}, 1000)

// Vue mixin
const Timer = {}
Timer.install = function (Vue) {
  Vue.mixin({
    // set timers on components mount
    // when option "timer" is set.
    // Call this function withing global timer interval
    mounted: function () {
      const timer = this.$options.timer
      if (timer) {
        timers.push({ id: this._uid, cb: () => this[timer].call() })
      }
    },
    // Remove timer callback for component
    // when component instance is destroyed
    beforeDestroy: function () {
      const idx = timers.findIndex((t) => t.id === this._uid)
      if (idx !== -1) {
        timers.splice(idx, 1)
      }
    }
  })
}

export default Timer
